import type { LoaderFunctionArgs } from '~/types/route-args';
import { loadElasticSearchResults } from '@modules/product-tagging/api/load-elastic-search-results.server';
import { loadOffPlatformSupplierStubSearchResults } from '@modules/product-tagging/api/load-off-platform-supplier-stub-search.server';
import {
    MIN_PROFESSIONAL_SEARCH_CHARACTERS,
    URL_SEARCH_PARAM,
} from '@modules/product-tagging/config/search-form';

export const ProductTaggingSupplierSearch =
    '/remix-api/product-tagging/supplier-search';

export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const searchTerm = url.searchParams.get(URL_SEARCH_PARAM) ?? '';

    if (searchTerm.length < MIN_PROFESSIONAL_SEARCH_CHARACTERS) {
        return [];
    }

    const [elasticResults, stubResults] = await Promise.all([
        loadElasticSearchResults({
            context,
            request,
            searchType: 'professional',
        }),
        loadOffPlatformSupplierStubSearchResults({
            context,
            searchTerm,
        }),
    ]);

    return [...stubResults, ...elasticResults];
};
